module.exports = __webpack_public_path__ + "img/iconArrowNavyDropDown.ce1b1418.png";